import { configureStore, Action, getDefaultMiddleware } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { rootReducer, RootState } from '.';
import { GhostBle } from '../ble/GhostBle';

export const store = configureStore({
  reducer: rootReducer,
  middleware: [...getDefaultMiddleware()],
});

GhostBle.initialize(store.dispatch, store.getState);

export type AppDispatch = typeof store.dispatch;

export type AppThunk<T> = ThunkAction<Promise<T>, RootState, null, Action<string>>;
